import { render, staticRenderFns } from "./DuelStudent.vue?vue&type=template&id=6e1f97fc&scoped=true"
import script from "./DuelStudent.vue?vue&type=script&lang=js"
export * from "./DuelStudent.vue?vue&type=script&lang=js"
import style0 from "./DuelStudent.vue?vue&type=style&index=0&id=6e1f97fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1f97fc",
  null
  
)

export default component.exports